// Звезда избранного: горит, только если id есть в наборе СЕРВЕРА; на время запроса заблокирована.
// Первое нажатие лениво создаёт сессию (гость / Telegram). Лимит — число из ответа сервера.
import { ApiError } from '../api/client';
import { t, type StringKey } from '../i18n/i18n';
import { FavoriteLimitError, type FavType, useFavorites, useToggleFavorite } from '../session/favorites';
import { haptic } from '../telegram/webapp';
import { toast } from './Toast';
import styles from './FavoriteStar.module.css';

const LIMIT_TEXT: Record<FavType, StringKey> = {
  team: 'mc_fav_limit_teams', league: 'mc_fav_limit_leagues', player: 'mc_fav_limit_players', match: 'mc_fav_limit_matches',
};

/** Звезда как переключатель: горит ли (набор сервера), идёт ли запрос, нажать. Им же выбирают плитки онбординга (HQ-1092). */
export function useFavoriteSwitch(type: FavType, id: number): { on: boolean; pending: boolean; toggle: () => void } {
  const set = useFavorites();
  const mutation = useToggleFavorite();
  const on = set[type].includes(id);
  const toggle = () => {
    haptic.impact();
    mutation.mutate({ type, id, on }, {
      onError: (err) => {
        if (err instanceof FavoriteLimitError) toast(t(LIMIT_TEXT[err.type], err.limit));
        else toast(err instanceof ApiError && err.kind === 'network' ? t('mc_offline') : t('mc_error_title'));
      },
    });
  };
  return { on, pending: mutation.isPending, toggle };
}

export function FavoriteStar({ type, id }: { type: FavType; id: number }) {
  const { on, pending, toggle } = useFavoriteSwitch(type, id);
  return (
    <button className={`${styles.star} ${on ? styles.on : ''}`} disabled={pending}
      aria-pressed={on} aria-label={t(on ? 'mc_fav_remove' : 'mc_fav_add')}
      onClick={(e) => {
        e.stopPropagation(); // звезда внутри строки матча — строку не открываем
        toggle();
      }}>
      <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" fill={on ? 'currentColor' : 'none'}
        stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round">
        <path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z" />
      </svg>
    </button>
  );
}
